export const OVERVIEW_EVENTS = {
    GOAL: "GOAL",
    PENALTY_GOAL: "PENALTY_GOAL", // one penalty goal in the game
    PENALTY_SAVED: "PENALTY_SAVED",
  
    YELLOW_CARD: "YELLOW_CARD",
    CORNER: "CORNER",
    INJURY_BREAK: "INJURY_BREAK",
    OFFSIDE: "OFFSIDE",
    PENALTY_AWARDED: "PENALTY_AWARDED",
    PENALTY_MISSED: "PENALTY_MISSED",
    RED_CARD: "RED_CARD",
    SHOT_OFF_THE_TARGET: "SHOT_OFF_THE_TARGET",
    SHOT_ON_THE_TARGET: "SHOT_ON_THE_TARGET",
    SUBSTITUTE: "SUBSTITUTE",
    VAR_CHECK: "VAR_CHECK",
    VAR_DECLINED: "VAR_DECLINED",
    VAR: "VAR",
    OWN_GOAL: "OWN_GOAL",
    MATCH_ENDED: "MATCH_ENDED",
    HALF_TIME: "HALF_TIME",
    FULL_TIME: "FULL_TIME",
    EXTRA_TIME: "EXTRA_TIME",
    PENALTIES: "PENALTIES", 
    PENALTIES_GOAL: "PENALTIES_GOAL", //penalty series goal after extra time
    PENALTIES_MISSED: "PENALTIES_MISSED", //penalty series missed after extra time
    PENALTIES_SAVED: "PENALTIES_SAVED", //penalty series saved after extra time
    ADDED_TIME: "ADDED_TIME",
    SECOND_YELLOW_CARD: "SECOND_YELLOW_CARD"
}

export const DESCRIPTION_TYPES = {
    GOAL: "GOAL",
    PENALTY: "PENALTY"
}

export const VAR_EVENTS = {
    VAR: "VAR",
    VAR_CHECK: "VAR_CHECK",
    VAR_DECLINED: "VAR_DECLINED"
}


export const VAR_EVENTS_LABELS = {
    VAR_GOAL: "Goal check",
    VAR_CHECK_GOAL: "Goal confirmed",
    VAR_DECLINED_GOAL: "No goal",
    VAR_PENALTY: "Penalty check",
    VAR_CHECK_PENALTY: "Penalty confirmed",
    VAR_DECLINED_PENALTY: "No penalty",
    EMPTY: ""
}

export enum ActiveFilterName {
    FULL_MATCH = 'full_match',
    FIRST_HALF = 'first_half',
    SECOND_HALF = 'second_half',
    OVERTIME = 'overtime'
}


export enum SCPlayersActiveFilterName {
    GOALS = 'goals',
    ASSISTS = 'assists',
    CARDS = 'cards',
    SHOTS = 'shots',
}

export enum H2HActiveFilterName {
    H2H = 'h2h',
    TABLE = 'table',
    QUARTER_FINALS = 'quarter_finals',
    ROUND_OF_16 = 'round_of_16',
    KNOCKOUT = 'knockout',
    QUALIFICATION = 'qualification',
    GROUPS_TABLES = 'groups_tables',
}

export enum UrlParams {
    EVENT_ID = 'eventId',
    THEME = 'theme',
    DEFAULT_STATS_CONSOLE_TAB = 'defSCTab',
    FIXTURES = 'fixtures',
    IS_MVP = 'isMVP',
    FIXED_HEIGHT = 'fixedHeight',
    PLATFORM = 'platform',
    LANG_MONITORING = 'langMonit',
    DYNAMIC_COLORS = 'isDynamicColors',
    VERSION = 'version',
    IOS = 'ios' 
}


export enum SCLineupPlayersActiveFilterName {
    XGOALS = 'xGoals',
    SHOTS = 'shots',
    BALL_TOUCHES = 'ballTouches',
    NULL = '',
}

export enum T {
    LIGHT = 'light',
    DARK = 'dark',
    E = 'E',
    W = 'W',
    F = 'F',
    L = 'L',
    D = 'D',
    TAB_STATS = 'InHouseStats.TabStats',
    TAB_OVERVIEW = 'InHouseStats.TabOverview',
    TAB_PLAYERS = 'InHouseStats.TabPlayers',
    TAB_LINEUP = 'InHouseStats.TabLineups',
    TAB_H2H = 'InHouseStats.TabH2H'
}

export enum Version {
    V1 = 'v1',
    V2 = 'v2'
}

export enum DefaultStatsConsoleTab {
    STATS = 'Stats',
    OVERVIEW = 'Overview',
    PLAYERS = 'Players',
    LINEUP = 'Lineup',
    H2H = 'H2H'
}
